<template>
  <div id="app">
    <router-view v-if="isShowView" />
    <div class="background-box"></div>
  </div>
</template>

<script>
import { bingAnswerAndGetUser, checkUrl, objectToQuery, OAUTH_INFO_API_URL } from 'dygc'
import { getPageScrollEl } from '@/assets/js/scroll'

export default {
  data() {
    return {
      isShowView: true
    }
  },
  methods: {},
  created() {
    let currentBrowserInfo = this.$bus.currentBrowserInfo
    if (this.$bus.params.isTest) {
      currentBrowserInfo.isPc = false
      const scrollEl = getPageScrollEl()
      scrollEl.classList.add('preview-wrap')
      return
    }
    if (currentBrowserInfo.isWeixin) {
      const params = this.$bus.params
      const origin = window.location.origin
      if (params.isTest) return
      if (params.answerType !== '1') {
        if (params.accountUserId || params.accountUserOpenId || params.token || params.code) {
          if (params.checkMpKey) {
            this.isShowView = false
            checkUrl(params.checkMpKey).then(res => {
              if (res.data) {
                if (params.viewAnswerId) {
                  this.$router.push({
                    name: 'preview',
                    params: {
                      id: params.viewAnswerId
                    }
                  })
                }
                this.isShowView = true
              } else {
                const data = {
                  surveyId: params.surveyId,
                  answerChannelId: params.answerChannelId
                }
                const url = `${origin}/mobile?${objectToQuery(data)}`
                window.location.replace(`${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(url)}`)
                return
              }
            })
            return
          } else {
            const checkTimestamp = Number(params.checkTimestamp) || 0
            const now = Date.now()
            if (now - checkTimestamp > 20 * 1000) {
              const ignores = [
                'token',
                'accountUserId',
                'accountUserOpenId',
                'accountUsername',
                'accountUserWxNickname',
                'code',
                'checkTimestamp',
                'id'
              ]
              const data = Object.keys(params).reduce((res, item) => {
                if (ignores.includes(item)) {
                  return res
                }
                res[item] = params[item]
                return res
              }, {})
              const url = `${origin}/mobile?${objectToQuery(data)}`
              window.location.replace(`${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(url)}`)
              this.isShowView = false
              return
            }
          }
        } else {
          if (!params.accountUserFingerprint) {
            const url = window.location.href.split('#')[0]
            window.location.replace(`${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(url)}`)
            this.isShowView = false
          }
        }
      }
      /*if (!params.accountUserId && !params.accountUserFingerprint && params.answerType !== '1') {
        // alert(`${origin}/award/oauthInfo?returnUrl=${encodeURIComponent(url)}`)
        const url = window.location.href.split('#')[0]
        window.location.replace(`${origin}/award/oauthInfo?returnUrl=${encodeURIComponent(url)}`)
        this.isShowView = false
        return
      } else {
        if ((params.accountUserId || params.token) && params.answerType !== '1') {
          const checkTimestamp = Number(params.checkTimestamp) || 0
          const now = Date.now()
          if (now - checkTimestamp > 20 * 1000) {
            const ignores = ['token', 'accountUserId', 'accountUsername', 'accountUserWxNickname']
            const data = Object.keys(params).reduce((res, item) => {
              if (ignores.includes(item)) {
                return res
              }
              res[item] = params[item]
              return res
            }, {})
            const url = `${origin}/mobile?${objectToQuery(data)}`
            window.location.replace(`${origin}/award/oauthInfo?returnUrl=${encodeURIComponent(url)}`)
            this.isShowView = false
            return
          }
        }
      }*/
    } else if (currentBrowserInfo.isPc) {
      window.location.replace(window.location.href.replace('mobile', 'pc'))
    }

    // const pageType = this.$bus.params.pageType || ''
    // if (pageType.toString() === '2') {
    //   this.$router.replace({
    //     name: 'award'
    //   })
    // }
  }
}
</script>

<style lang="scss">
#app {
  width: 100vw;
  height: 100vh;
  overflow-y: auto;
}
</style>
